import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, AppBar, Toolbar, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    justifyContent: 'center',
    background: '#ffffff',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.08)',
    height: 80,
  },
  logoContainer: {
    flexGrow: 1,
    paddingLeft: theme.spacing(3),
  },
  selectedMenu: {
    marginRight: theme.spacing(3),
    color: '#233C97',
    fontSize: 16,
  },
  notSelectedMenu: {
    marginRight: theme.spacing(3),
    color: '#000000',
    fontSize: 16,
  },
}));

const TopBar = () => {
  const classes = useStyles();
  const menu = [
    { title: 'About' },
    { title: 'Contact' },
    { title: 'Download' },
    { title: 'Register' },
  ];
  const [selectedMenu, setSelectedMenu] = React.useState(-1);

  return (
    <div>
      <AppBar className={classes.root}>
        <Toolbar>
          <Box className={classes.logoContainer}>
            <img
              src={
                'https://pharmacyone-images.s3.ap-south-1.amazonaws.com/logo/1P-logo.png'
              }
              style={{ height: 60, objectFit: 'contain' }}
            />
          </Box>
          {menu.map((menuItem, index) => (
            <Button
              className={
                index == selectedMenu
                  ? classes.selectedMenu
                  : classes.notSelectedMenu
              }
              onClick={() => setSelectedMenu(index)}
            >
              <Typography>{menuItem.title}</Typography>
            </Button>
          ))}
        </Toolbar>
      </AppBar>
    </div>
  );
};
export default TopBar;
